import { StatusEnum } from "./status-enum";

export const statusColors = {
  [StatusEnum.DELIVERED]: "default",
  [StatusEnum.PARTIALLY_INVOICED]: "warning",
  [StatusEnum.FULLY_INVOICED]: "success",
};
